import { render, staticRenderFns } from "./SpaceScreenView.vue?vue&type=template&id=f39f0ae6&"
import script from "./SpaceScreenView.vue?vue&type=script&lang=js&"
export * from "./SpaceScreenView.vue?vue&type=script&lang=js&"
import style0 from "./SpaceScreenView.vue?vue&type=style&index=0&id=f39f0ae6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports